import '../styles/globals.css';
import type { AppProps } from 'next/app';
import '@livekit/components-styles';
import '@livekit/components-styles/prefabs';
import '@rainbow-me/rainbowkit/styles.css';
import { DefaultSeo } from 'next-seo';
import WagmiConfigRoot from '../components/WagmiRoot';
import React from 'react';
import SocialMeta from '../components/SocialMeta';
import { defaultSocialMeta } from '../lib/social-meta';

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <DefaultSeo
        title="IM3"
        titleTemplate="%s"
        defaultTitle="IM3"
        additionalMetaTags={[
          {
            property: 'theme-color',
            content: '#070707',
          },
        ]}
        additionalLinkTags={[
          {
            rel: 'icon',
            href: '/images/im3-icon.svg',
          },
          {
            rel: 'apple-touch-icon',
            href: '/images/im3-icon.svg',
            sizes: '180x180',
          },
          {
            rel: 'mask-icon',
            href: '/images/im3-icon.svg',
            color: '#070707',
          },
        ]}
      />
      {/* Pages with getServerSideProps pass absolute, per-page values; others get IM3 defaults. */}
      <SocialMeta {...(pageProps.socialMeta ?? defaultSocialMeta())} />
      <WagmiConfigRoot>
        <Component {...pageProps} />
      </WagmiConfigRoot>
    </>
  );
}

export default MyApp;
